export default __webpack_public_path__ + "static/media/Microcentrifuge.db207c56.svg";